import { gql } from '@apollo/client'

export default gql(`
    mutation($imageObjArray: [updateAssetMediaLinkInput]) {
        batchCreateAssetMediaLink(input: $imageObjArray ) {
                id
                type
                category{
                    id
                    label
                    type
                }
        }
    }`
)
